module.exports = __webpack_public_path__ + "img/avatar4.1bc4efc8.png";